import React from "react";
import {
  Document,
  Page,
  StyleSheet,
  Image,
  Text,
  View,
  pdf,
  Font,
} from "@react-pdf/renderer";
import logo from "../../../assets/logo.png";
import load from "../../../assets/load.png";
import unload from "../../../assets/unload.png";
import goods from "../../../assets/goods.png";
import img from "../../../assets/Picture1.png";
import footerOne from "../../../assets/footerOne.png";
import term from "../../../assets/termss.png";
import { AmountFormat } from "../../../lib/helper/amountFormat";
import { FormatDate } from "../../../lib/dateFormat";

Font.registerHyphenationCallback((word) => [word]);

const styles = StyleSheet.create({
  rightImage: {
    position: "absolute",
    right: 0,
    top: 0,
  },
  footerOne: {
    position: "absolute",
    left: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderBottom: "7px solid #DA1C00",
  },
  footerTextContainer: {
    maxWidth: "60%", // Constrain text width to prevent stretching
    textAlign: "center",
  },
  footerTextInside: {
    fontSize: 8,
    color: "gray",
    fontFamily: "Helvetica",
    textAlign: "center",
    marginTop: 5,
    marginBottom: 2, // Reduced spacing between lines
    lineHeight: 1.1, // Control line height more tightly
  },
  footerTextUrl: {
    fontSize: 8,
    color: "gray",
    fontFamily: "Helvetica",
    textAlign: "center",
    marginBottom: 5, // Space below URL to avoid overlap with red line
    lineHeight: 1.1, // Control line height more tightly
  },
  page: {
    flexDirection: "column",
    paddingBottom: "50px",
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    position: "relative",
  },
  page2: {
    flexDirection: "column",
    position: "relative",
  },
  section: {
    marginBottom: 10,
  },
  logo: {
    width: 100,
    marginBottom: 10,
  },
  logo1: {
    width: "150px",
    marginBottom: 10,
  },
  companyInfo: {
    marginBottom: 18,
  },
  companyName: {
    color: "#17365d",
    fontSize: 9,
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  companyText: {
    fontSize: 8,
    marginBottom: 2,
  },
  logo2: {
    width: 400,
    marginBottom: 5,
  },
  termPage: {
    height: "100vh",
    width: "100%",
  },
  terms: {
    width: "100%",
    marginBottom: 5,
  },
  title: {
    fontSize: 10,
    marginBottom: 5,
    textTransform: "uppercase",
  },
  title1: {
    color: "red",
    fontSize: "13px",
    marginBottom: 5,
    textTransform: "uppercase"
  },
  title2: {
    fontSize: 10,
    textTransform: "uppercase",
  },
  text: {
    fontSize: 10,
    marginBottom: 5,
    padding: "1px 0",
  },
  text1: {
    fontSize: 10,
    marginBottom: 2,
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "start",
    justifyContent: "space-between",
    gap: 10,
  },
  section1: {
    width: "32%",
    flexDirection: "column",
    gap: 5,
  },
  section2: {
    width: "100%",
    flexDirection: "column",
    gap: 2,
    marginTop: 15,
  },
  imgBox: {
    flexDirection: "row",
    alignItems: "baseline",
    gap: "2px",
    width: "100%",
    borderBottom: "0.5px solid black",
    paddingBottom: 2,
    marginBottom: 3,
    height: 20,
  },
  img: {
    width: 10,
  },
  rowBox: {
    flexDirection: "row",
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
  },
  rowBox1: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 3,
  },
  statBox: {
    flexDirection: "column",
    gap: 5,
    marginBottom: 2,
    justifyContent: "start",
  },
  statBox1: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "20%",
  },
  statBox2: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "25%",
  },
  statBox3: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "40%",
  },
  statBox4: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "13%",
  },
  statBox5: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "start",
    width: "30%",
  },
  statTitle: {
    color: "gray",
    fontSize: 10,
    textTransform: "uppercase",
  },
  statValue: {
    fontSize: 10,
  },
  statValue1: {
    fontSize: 10,
    textTransform: "uppercase",
  },
  totalSection: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: "30px",
    position: "relative",
    bottom: 10,
    right: 10,
  },
  totalBox: {
    width: "38%",
    flexDirection: "column",
    borderBottom: "0.5px solid black",
    borderTop: "0.5px solid black",
    gap: 3,
    marginTop: 30,
    padding: 5,
    alignSelf: "flex-end",
  },
  totalLabelCol: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "flex-start",
    width: "48%",
  },
  totalUnitCol: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "flex-start",
    width: "18%",
  },
  totalAmountCol: {
    flexDirection: "column",
    gap: 5,
    justifyContent: "flex-start",
    width: "34%",
  },
  totalRow: {
    flexDirection: "row",
    width: "100%",
    borderBottom: "0.5px solid black",
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
  },
  totalRow1: {
    flexDirection: "row",
    width: "100%",
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
  },
  discountRow: {
    flexDirection: "row",
    width: "100%",
    borderBottom: "0.5px solid #fb923c",
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
    backgroundColor: "#fff7ed",
  },
  discountText: {
    fontSize: 9.5,
    color: "#ea580c",
  },
});

const PDFDocument = ({ estimate, clientEstimateSummary, dhlEstimation }) => {
  // Helpers to safely derive displayable city/country
  const getLoadCityCountry = () => {
    const city = estimate.loadCity || estimate.originCity || '';
    const country = estimate.loadCountry || estimate.originCountry || '';
    return city || country ? `${city}${city && country ? ', ' : ''}${country}` : null;
  };
  const getUnloadCityCountry = () => {
    const city = estimate.unloadCity || estimate.destinationCity || '';
    const country = estimate.unloadCountry || estimate.destinationCountry || '';
    return city || country ? `${city}${city && country ? ', ' : ''}${country}` : null;
  };
  // Calculate Cargo Value
  const cargoValue = estimate.items.reduce(
    (sum, item) => sum + (parseFloat(item.itemValue) || 0) * (parseFloat(item.quantity) || 0),
    0
  );

  // Calculate Airfreight
  const totalWeight = estimate.dimensions.reduce(
    (sum, dim) => sum + (parseFloat(dim.weight.value) || 0),
    0
  );
  const totalVolumetricWeight = estimate.dimensions.reduce((sum, dim) => {
    const volumetricWeight =
      (parseFloat(dim.length.value) * parseFloat(dim.width.value) * parseFloat(dim.height.value)) / 6000;
    return sum + volumetricWeight;
  }, 0);
  const airfreight = Math.max(totalWeight, totalVolumetricWeight);

  // Calculate Insurance
  const insurance = estimate.insuranceSelected === "YES" ? cargoValue * 0.0075 : 0;

  // Calculate CIF
  const cifValue = cargoValue * 1.10;

  // Determine which currency to use in PDF
  const pdfCurrency = (estimate.itemsCurrency !== clientEstimateSummary?.currency)
    ? clientEstimateSummary?.currency || estimate.itemsCurrency
    : estimate.itemsCurrency;

  // Prepare user info
  const userInfo = {
    name: estimate.userName || "N/A",
    email: estimate.email || "N/A",
    city: estimate.userCity || "N/A",
    country: estimate.userCountry || "N/A",
    postalCode: estimate.postalCode || "N/A",
  };

  // Prepare dimensions
  const formatKg = (n) => (isNaN(n) ? '0.00' : n.toFixed(2));

  const dimensions = estimate.dimensions.map((dim) => {
    const qty = parseFloat(dim.quantity.value) || 1;
    const length = parseFloat(dim.length.value) || 0;
    const width = parseFloat(dim.width.value) || 0;
    const height = parseFloat(dim.height.value) || 0;
    const weight = parseFloat(dim.weight.value) || 0;

    // Volumetric weight PER PIECE using cm divisor 6000
    const volumetricPerPiece = (length * width * height) / 6000;
    // Line totals should respect quantity
    const volumetricTotal = volumetricPerPiece * qty;
    const grossTotal = weight * qty;
    const chargeableTotal = Math.max(volumetricTotal, grossTotal);

    return {
      quantity: qty,
      length: `${dim.length.value} ${dim.length.unit}`,
      width: `${dim.width.value} ${dim.width.unit}`,
      height: `${dim.height.value} ${dim.height.unit}`,
      // Show gross weight TOTAL for the line (weight per piece × quantity)
      weight: `${formatKg(grossTotal)} ${dim.weight.unit}`,
      volumetricWeight: `${formatKg(volumetricTotal)} ${dim.weight.unit}`,
      chargeableWeight: `${formatKg(chargeableTotal)} ${dim.weight.unit}`,
    };
  });

  const services = clientEstimateSummary?.services?.map((service) => ({
    quantity: 1,
    description: service.description,
    exclVAT: service.value,
    total: service.value,
  })) || [];

  const dhlTaxes = dhlEstimation?.feeTotals?.map((tax) => ({
    quantity: 1,
    description: tax.name,
    exclVAT: tax.value,
    total: tax.value,
  })) || [];

  const subTotal = services.reduce((sum, s) => sum + s.total, 0);
  const vatPercentage = parseFloat(estimate.vatPercentage || 0);
  const vatAmount = subTotal * (vatPercentage / 100);
  const totalTaxes = dhlTaxes.reduce((sum, t) => sum + t.total, 0);

  let rawDiscount = estimate?.discount || estimate?.tradeOSData?.discount || null;
  let parsedDiscount = null;
  if (typeof rawDiscount === 'number' || (typeof rawDiscount === 'string' && !isNaN(Number(rawDiscount)))) {
    const num = Number(rawDiscount);
    if (num > 0) {
      parsedDiscount = { type: 'fixed', value: num, amount: num };
    }
  } else if (rawDiscount && typeof rawDiscount === 'object') {
    const amt = Number(rawDiscount.amount ?? (rawDiscount.type === 'fixed' ? rawDiscount.value : 0));
    if (amt > 0) {
      parsedDiscount = {
        ...rawDiscount,
        amount: amt,
        type: rawDiscount.type || 'fixed',
        value: rawDiscount.value ?? amt,
      };
    } else if (rawDiscount.type === 'percentage' && Number(rawDiscount.value) > 0 && subTotal > 0) {
      parsedDiscount = {
        ...rawDiscount,
        amount: (subTotal * Number(rawDiscount.value)) / 100,
        type: 'percentage',
        value: Number(rawDiscount.value),
      };
    }
  }
  const discount = parsedDiscount;
  const hasDiscount = discount && discount.amount > 0;
  const discountAmount = hasDiscount ? Number(discount.amount) : 0;
  const discountedSubTotal = Math.max(0, subTotal - discountAmount);
  const grandTotal = discountedSubTotal + vatAmount + insurance + totalTaxes;

  // Alternative condition: Check if data is from CompleteEstimationForm
  // Consider it complete only if we actually have detailed load/unload fields,
  // not just country codes; otherwise fall back gracefully.
  const isCompleteEstimationForm = Boolean(
    estimate.loadAddress || estimate.unloadAddress ||
    estimate.loadCity || estimate.unloadCity ||
    estimate.loadCompanyName || estimate.unloadCompanyName
  );

  return (
    <Document>
      <Page wrap size="A4" style={styles.page}>
        <View fixed style={styles.rightImage}>
          <Image src={img} style={styles.logo1} />
        </View>
        <Image fixed src={logo} style={styles.logo} />
        <View style={styles.companyInfo}>
          <Text style={styles.companyName}>One Union Solutions B.V.</Text>
          <Text style={styles.companyText}>Legmeerdijk 169C</Text>
          <Text style={styles.companyText}>1432 KA Aalsmeer</Text>
          <Text style={styles.companyText}>Netherlands</Text>
          <Text style={styles.companyText}>P: +31 850600753</Text>
          <Text style={styles.companyText}>E: info@oneunionsolutions.com</Text>
        </View>
        <Text style={styles.title1}>Client</Text>
        <View style={styles.section}>
          <Text style={styles.text}>{userInfo.name}</Text>
          <Text style={styles.text}>{userInfo.email}</Text>
          <Text style={styles.text}>
            {userInfo.city}, {userInfo.country}, {userInfo.postalCode}
          </Text>
          <Text style={styles.title1}>
            {estimate.estimationAccept
              ? `QUOTATION NUMBER: ${estimate.estimateId}`
              : `PROPOSAL NUMBER: ${estimate.estimateId}`}
          </Text>
        </View>

        <View style={styles.rowContainer}>
          <View style={styles.section1}>
            <View style={styles.imgBox}>
              <Image src={load} style={styles.img} />
              <Text style={styles.title2}>Load Address</Text>
            </View>
            {isCompleteEstimationForm ? (
              <>
                {estimate.loadName && <Text style={styles.text1}>Name: {estimate.loadName}</Text>}
                {estimate.loadCompanyName && <Text style={styles.text1}>Company: {estimate.loadCompanyName}</Text>}
                {estimate.loadReferenceCustomer && <Text style={styles.text1}>Ref: {estimate.loadReferenceCustomer}</Text>}
                {estimate.loadAddress && <Text style={styles.text1}>Address: {estimate.loadAddress}</Text>}
                {getLoadCityCountry() && (
                  <Text style={styles.text1}>{getLoadCityCountry()}</Text>
                )}
                {estimate.loadZipCode && <Text style={styles.text1}>Zip Code: {estimate.loadZipCode}</Text>}
                {estimate.loadMobileNumber && <Text style={styles.text1}>Phone: {estimate.loadMobileNumber}</Text>}
              </>
            ) : (
              <>
                <Text style={styles.text1}>
                  {estimate.loadAddress || `${estimate.originCity}, ${estimate.originCountry}`}
                </Text>
                {estimate.loadAddress_CompanyName && (
                  <Text style={styles.text1}>Company: {estimate.loadAddress_CompanyName}</Text>
                )}
                {estimate.loadAddress_PhoneNumber && (
                  <Text style={styles.text1}>Phone: {estimate.loadAddress_PhoneNumber}</Text>
                )}
                {estimate.loadAddress_ReferenceCustomer && (
                  <Text style={styles.text1}>Ref: {estimate.loadAddress_ReferenceCustomer}</Text>
                )}
                {estimate.postalCode && (
                  <Text style={styles.text1}>Postal Code: {estimate.postalCode}</Text>
                )}
              </>
            )}
          </View>
          <View style={styles.section1}>
            <View style={styles.imgBox}>
              <Image src={unload} style={styles.img} />
              <Text style={styles.title2}>Unload Address</Text>
            </View>
            {isCompleteEstimationForm ? (
              <>
                {estimate.unloadName && <Text style={styles.text1}>Name: {estimate.unloadName}</Text>}
                {estimate.unloadCompanyName && <Text style={styles.text1}>Company: {estimate.unloadCompanyName}</Text>}
                {estimate.unloadReferenceCustomer && <Text style={styles.text1}>Ref: {estimate.unloadReferenceCustomer}</Text>}
                {estimate.unloadAddress && <Text style={styles.text1}>Address: {estimate.unloadAddress}</Text>}
                {getUnloadCityCountry() && (
                  <Text style={styles.text1}>{getUnloadCityCountry()}</Text>
                )}
                {estimate.unloadZipCode && <Text style={styles.text1}>Zip Code: {estimate.unloadZipCode}</Text>}
                {estimate.unloadMobileNumber && <Text style={styles.text1}>Phone: {estimate.unloadMobileNumber}</Text>}
              </>
            ) : (
              <>
                <Text style={styles.text1}>
                  {estimate.unloadAddress || `${estimate.destinationCity}, ${estimate.destinationCountry}`}
                </Text>
                {estimate.unloadAddress_CompanyName && (
                  <Text style={styles.text1}>Company: {estimate.unloadAddress_CompanyName}</Text>
                )}
                {estimate.unloadAddress_PhoneNumber && (
                  <Text style={styles.text1}>Phone: {estimate.unloadAddress_PhoneNumber}</Text>
                )}
                {estimate.unloadAddress_ReferenceCustomer && (
                  <Text style={styles.text1}>Ref: {estimate.unloadAddress_ReferenceCustomer}</Text>
                )}
                {estimate.unloadPostalCode && (
                  <Text style={styles.text1}>Postal Code: {estimate.unloadPostalCode}</Text>
                )}
              </>
            )}
          </View>
          <View style={styles.section1}>
            <View style={styles.imgBox}>
              <Text style={styles.title2}>Details</Text>
            </View>
            <Text style={styles.text1}>Date: {FormatDate(estimate.createdAt?.$date)}</Text>
            <Text style={styles.text1}>Cargo Value: {AmountFormat(cargoValue, pdfCurrency)}</Text>
            <Text style={styles.text1}>CIF Value: {AmountFormat(cifValue, pdfCurrency)}</Text>
            <Text style={styles.text1}>Transportation Mode: {estimate.modeOfTransfer || "AIR"}</Text>
          </View>
        </View>

        <View style={styles.section2}>
          <View style={styles.imgBox}>
            <Image src={goods} style={styles.img} />
            <Text style={styles.title2}>Goods</Text>
          </View>
          {dimensions.map((dim, index) => (
            <View key={index} style={styles.rowBox}>
              <View style={styles.statBox4}>
                {index === 0 && <Text style={styles.statTitle}>Quantity</Text>}
                <Text style={styles.statValue}>{dim.quantity}</Text>
              </View>
              <View style={styles.statBox5}>
                {index === 0 && <Text style={styles.statTitle}>Dimensions</Text>}
                <Text style={styles.statValue1}>{`${dim.length} x ${dim.width} x ${dim.height}`}</Text>
              </View>
              <View style={styles.statBox1}>
                {index === 0 && <Text style={styles.statTitle}>Gross Weight</Text>}
                <Text style={styles.statValue1}>{dim.weight}</Text>
              </View>
              <View style={styles.statBox1}>
                {index === 0 && <Text style={styles.statTitle}>Volume Weight</Text>}
                <Text style={styles.statValue1}>{dim.volumetricWeight}</Text>
              </View>
              <View style={styles.statBox2}>
                {index === 0 && <Text style={styles.statTitle}>Chargeable Weight</Text>}
                <Text style={styles.statValue1}>{dim.chargeableWeight}</Text>
              </View>
            </View>
          ))}
        </View>

        <View style={styles.section2}>
          <View style={styles.imgBox}>
            <Image src={goods} style={styles.img} />
            <Text style={styles.title2}>Services</Text>
          </View>
          {services.map((service, index) => (
            <View style={styles.rowBox} key={index}>
              <View style={styles.statBox1}>
                {index === 0 && <Text style={styles.statTitle}>Quantity</Text>}
                <Text style={styles.statValue}>{service.quantity}</Text>
              </View>
              <View style={styles.statBox3}>
                {index === 0 && <Text style={styles.statTitle}>Description</Text>}
                <Text style={styles.statValue}>{service.description}</Text>
              </View>
              <View style={styles.statBox1}>
                {index === 0 && <Text style={styles.statTitle}>excl.VAT</Text>}
                <Text style={styles.statValue}>{AmountFormat(service.exclVAT, pdfCurrency)}</Text>
              </View>
              <View style={styles.statBox1}>
                {index === 0 && <Text style={styles.statTitle}>Total</Text>}
                <Text style={styles.statValue}>{AmountFormat(service.total, pdfCurrency)}</Text>
              </View>
            </View>
          ))}
        </View>

        {dhlTaxes.length > 0 && (
          <View style={styles.section2}>
            <View style={styles.imgBox}>
              <Image src={goods} style={styles.img} />
              <Text style={styles.title2}>Duties and Taxes</Text>
            </View>
            {dhlTaxes.map((tax, index) => (
              <View style={styles.rowBox} key={index}>
                <View style={styles.statBox1}>
                  {index === 0 && <Text style={styles.statTitle}>Quantity</Text>}
                  <Text style={styles.statValue}>{tax.quantity}</Text>
                </View>
                <View style={styles.statBox3}>
                  {index === 0 && <Text style={styles.statTitle}>Description</Text>}
                  <Text style={styles.statValue}>{tax.description}</Text>
                </View>
                <View style={styles.statBox1}>
                  {index === 0 && <Text style={styles.statTitle}>excl.VAT</Text>}
                  <Text style={styles.statValue}>{AmountFormat(tax.exclVAT, pdfCurrency)}</Text>
                </View>
                <View style={styles.statBox1}>
                  {index === 0 && <Text style={styles.statTitle}>Total</Text>}
                  <Text style={styles.statValue}>{AmountFormat(tax.total, pdfCurrency)}</Text>
                </View>
              </View>
            ))}
          </View>
        )}

        <View style={styles.totalSection} wrap={false}>
          <View style={styles.totalBox}>
            <View style={styles.totalRow}>
              <View style={styles.totalLabelCol}>
                <Text style={styles.statTitle}>Subtotal</Text>
                <Text style={styles.statValue}>VAT %</Text>
                {totalTaxes > 0 && <Text style={styles.statValue}>Taxes</Text>}
              </View>
              <View style={styles.totalUnitCol}>
                <Text style={styles.statValue}>{pdfCurrency}</Text>
                <Text style={styles.statValue}>{vatPercentage}%</Text>
                {totalTaxes > 0 && <Text style={styles.statValue}>{pdfCurrency}</Text>}
              </View>
              <View style={styles.totalAmountCol}>
                <Text style={styles.statValue}>{AmountFormat(subTotal, pdfCurrency)}</Text>
                <Text style={styles.statValue}>{AmountFormat(vatAmount, pdfCurrency)}</Text>
                {totalTaxes > 0 && <Text style={styles.statValue}>{AmountFormat(totalTaxes, pdfCurrency)}</Text>}
              </View>
            </View>

            {hasDiscount && (
              <View style={styles.discountRow}>
                <View style={styles.totalLabelCol}>
                  <Text style={styles.discountText}>
                    Discount ({discount.type === 'percentage'
                      ? `${Math.abs(discount.value)}%`
                      : `Fixed`})
                  </Text>
                </View>
                <View style={styles.totalUnitCol}>
                  <Text style={styles.discountText}>{pdfCurrency}</Text>
                </View>
                <View style={styles.totalAmountCol}>
                  <Text style={styles.discountText}>
                    - {AmountFormat(discount.amount, pdfCurrency)}
                  </Text>
                </View>
              </View>
            )}

            <View style={styles.totalRow1}>
              <View style={styles.totalLabelCol}>
                <Text style={styles.statValue}>TOTAL</Text>
              </View>
              <View style={styles.totalUnitCol}>
                <Text style={styles.statValue}>{pdfCurrency}</Text>
              </View>
              <View style={styles.totalAmountCol}>
                <Text style={styles.statValue}>{AmountFormat(grandTotal - insurance, pdfCurrency)}</Text>
              </View>
            </View>
          </View>
        </View>

        <View fixed style={styles.footerOne} wrap={false}>
          <View style={styles.footerTextContainer}>
            <Text style={{
              ...styles.footerTextInside,
              fontWeight: 'light', // Using lighter weight to simulate italic appearance
              textDecoration: 'underline', // Adding subtle emphasis since italic isn't working
            }}>
              This quotation and any resulting services are governed by our Terms and Conditions,
            </Text>
            <Text style={{
              ...styles.footerTextUrl,
              fontWeight: 'light', // Using lighter weight to simulate italic appearance
              textDecoration: 'underline', // Adding subtle emphasis since italic isn't working
            }}>
              which are available at https://oneunionsolutions.com/terms-and-conditions/
            </Text>
          </View>
        </View>
      </Page>
      {/* <Page size="A4" style={styles.page2}>
        <View style={styles.termPage} wrap={false}>
          <Image src={term} style={styles.terms} />
        </View>
      </Page> */}
    </Document>
  );
};

export const generateIOR = async (estimate, clientEstimateSummary, dhlEstimation) => {
  const pdfBlob = await pdf(
    <PDFDocument
      estimate={estimate}
      clientEstimateSummary={clientEstimateSummary}
      dhlEstimation={dhlEstimation}
    />
  ).toBlob();
  return pdfBlob;
};
